(() => {
  const memoryKey = handle => 'lottys-uk-order:' + handle;
  const readMemory = handle => { try { return JSON.parse(sessionStorage.getItem(memoryKey(handle)) || '{}'); } catch { return {}; } };
  const remember = (handle, value) => { try { sessionStorage.setItem(memoryKey(handle), JSON.stringify(value)); } catch {} };
  document.querySelectorAll('[data-uk-link]').forEach(wrapper => {
    const link = wrapper.querySelector('a');
    const postcodeNotice = wrapper.nextElementSibling?.matches('[data-uk-postcode-notice]') ? wrapper.nextElementSibling : null;
    const mount = () => {
      const form = document.getElementById(wrapper.dataset.form);
      const picker = form?.querySelector('.buunto-method-picker');
      if (picker && !picker.querySelector('.lottys-uk-tile')) {
        picker.append(link);
        wrapper.hidden = true;
      }
      const widget = form?.querySelector('.buunto-date-picker');
      if (widget && postcodeNotice && widget.nextElementSibling !== postcodeNotice) widget.after(postcodeNotice);
      const postcode = form?.querySelector('.buunto-postcode-checker-input-row .buunto-error');
      const error = postcode?.closest('.buunto-field')?.querySelector('.buunto-error-tooltip');
      const rejected = error?.textContent.trim() === "Sorry, we don't deliver to this postcode.";
      if (postcodeNotice) postcodeNotice.hidden = !rejected;
    };
    const continueNationwide = event => {
      const target = event.currentTarget;
      const form = document.getElementById(wrapper.dataset.form);
      const variant = form?.querySelector('[name="id"]')?.value;
      const message = form?.querySelector('[name="properties[Card message]"]')?.value || '';
      const quantity = document.querySelector('[name="quantity"][form="' + wrapper.dataset.form + '"]')?.value || '1';
      const url = new URL(link.href);
      if (variant) url.searchParams.set('variant', variant);
      target.href = url.href;
      remember(wrapper.dataset.product, {...readMemory(wrapper.dataset.product), message, quantity, occasion:form?.elements.namedItem('properties[Occasion]')?.value || '', preferences:form?.elements.namedItem('properties[Flower or colour preferences]')?.value || ''});
    };
    link.addEventListener('click', continueNationwide);
    postcodeNotice?.querySelector('a')?.addEventListener('click', continueNationwide);
    const existing = readMemory(wrapper.dataset.product);
    const card = document.getElementById(wrapper.dataset.form)?.querySelector('[name="properties[Card message]"]');
    if (card && existing.message) card.value = existing.message;
    for (const [name,key] of [['Occasion','occasion'],['Flower or colour preferences','preferences']]) { const field=document.getElementById(wrapper.dataset.form)?.elements.namedItem('properties['+name+']'); if(field && existing[key]) field.value=existing[key]; }
    mount();
    const observer = new MutationObserver(mount);
    observer.observe(wrapper.closest('product-form') || document.getElementById('MainContent'), {childList:true, subtree:true, characterData:true});
    window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
  });
  const form = document.querySelector('[data-uk-order-form]');
  if (!form) return;
  const handle = form.dataset.product;
  const variant = form.querySelector('[name="id"]');
  const quantity = form.querySelector('[name="quantity"]');
  const message = form.querySelector('[name="properties[Card message]"]');
  const date = form.querySelector('[name="properties[Preferred arrival date]"]');
  const price = document.querySelector('[data-uk-price]');
  const back = document.querySelector('[data-uk-back]');
  const previous = readMemory(handle);
  if (previous.message) message.value = previous.message;
  if (previous.quantity) quantity.value = previous.quantity;
  const occasion = form.elements.namedItem('properties[Occasion]');
  const preferences = form.elements.namedItem('properties[Flower or colour preferences]');
  if (occasion && previous.occasion) occasion.value = previous.occasion;
  if (preferences && previous.preferences) preferences.value = previous.preferences;
  const holidays = new Set('2026-01-01,2026-04-03,2026-04-06,2026-05-04,2026-05-25,2026-08-31,2026-12-25,2026-12-28,2027-01-01,2027-03-26,2027-03-29,2027-05-03,2027-05-31,2027-08-30,2027-12-27,2027-12-28,2028-01-03,2028-04-14,2028-04-17,2028-05-01,2028-05-29,2028-08-28,2028-12-25,2028-12-26'.split(','));
  const londonToday = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
  const earliest = new Date(londonToday + 'T12:00:00Z');
  const iso = value => value.toISOString().slice(0,10);
  let days = Number(form.dataset.leadDays);
  while (days > 0) { earliest.setUTCDate(earliest.getUTCDate() + 1); if (![0,6].includes(earliest.getUTCDay()) && !holidays.has(iso(earliest))) days--; }
  date.min = iso(earliest);
  const preorderDate = form.querySelector('[data-uk-earliest-arrival]')?.value;
  if (preorderDate && date.min < preorderDate) date.min = preorderDate;
  const selection = form.querySelector('[name="properties[__buunto_selection]"]');
  const formattedDate = form.querySelector('[name="properties[Delivery Date]"]');
  const error = document.querySelector('[data-uk-error]');
  const submit = form.querySelector('[type="submit"]');
  let availability = new Map();
  let availabilityVersion = 0;
  const showError = text => { error.textContent = text; error.hidden = false; };
  const loadAvailability = async () => {
    const requestVersion = ++availabilityVersion;
    submit.disabled = true;
    availability = new Map();
    date.setCustomValidity('Delivery dates are loading. Please wait.');
    try {
      const url = new URL('https://datepicker.buunto.com/api/v1/available_dates');
      url.search = new URLSearchParams({shop:form.dataset.shop,withTimeSlots:'false',productVariantIds:variant.value});
      const response = await fetch(url);
      if (!response.ok) throw new Error('UK-wide delivery dates could not be loaded. Please try again shortly.');
      const result = await response.json();
      if (requestVersion !== availabilityVersion) return;
      const choices = (result.SHIPPING || []).filter(value => !value.soldOut && value.date >= date.min && !holidays.has(value.date) && new Date(value.date+'T12:00:00Z').getUTCDay() !== 0);
      availability = new Map(choices.map(value => [value.date,value]));
      if (!availability.size) throw new Error('UK-wide ordering is being prepared. No arrival dates are available yet; please use local delivery or collection, or contact our florists.');
      date.min = choices[0].date;
      date.max = choices[choices.length-1].date;
      date.setCustomValidity('');
      error.hidden = true;
      submit.disabled = false;
    } catch (failure) {
      if (requestVersion !== availabilityVersion) return;
      date.setCustomValidity('UK-wide delivery dates are not available yet.');
      showError(failure.message);
    }
  };
  const validateDate = () => {
    const chosen = availability.get(date.value);
    date.setCustomValidity(chosen ? '' : 'Please choose an available preferred arrival date.');
    selection.value = chosen ? 'SHIPPING|' + chosen.date + '||' : '';
    formattedDate.value = chosen ? chosen.formatted : '';
  };
  date.addEventListener('change',validateDate);
  variant.addEventListener('change',loadAvailability);
  loadAvailability();
  const sync = () => {
    price.textContent = variant.selectedOptions[0].dataset.price;
    const url = new URL(location.href); url.searchParams.set('variant', variant.value); history.replaceState({}, '', url);
    const returnUrl = new URL(back.href); returnUrl.searchParams.set('variant', variant.value); back.href = returnUrl.href;
    remember(handle, {message:message.value, quantity:quantity.value, occasion:occasion?.value || '', preferences:preferences?.value || ''});
  };
  form.addEventListener('input', sync);
  variant.addEventListener('change', sync);
  sync();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    validateDate();
    if (!form.reportValidity()) return;
    error.hidden = true;
    submit.disabled = true;
    try {
      await loadAvailability();
      validateDate();
      if (!availability.has(date.value)) { submit.disabled = !availability.size; form.reportValidity(); return; }
      submit.disabled = true;
      const currentCart = await fetch(window.Shopify.routes.root + 'cart.js').then(response => { if (!response.ok) throw new Error('Please refresh your basket and try again.'); return response.json(); });
      const incompatible = currentCart.items.some(item => item.properties?.['Delivery method'] !== 'UK-wide delivery' || item.properties?.['Preferred arrival date'] !== date.value);
      if (incompatible) throw new Error('Please order UK-wide flowers separately from local delivery, collection or flowers for a different arrival date. Complete your existing basket first.');
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      location.href = window.Shopify.routes.root + 'cart';
    } catch (failure) { error.textContent = failure.message; error.hidden = false; submit.disabled = false; }
  });
})();
